import { Box, Button, CircularProgress, Modal } from "@mui/material";
import { sxButton, sxModal, sxOutlinedButton } from "../../SaudeOnline/AgendarConsulta/sxProps";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import './styles.css';
import { ActivationGuideModalProps } from "../../../interfaces/props/GuiasEAutorizacoes/ActivationGuideModalProps";
import { useState } from "react";
import { ativarGuiaFutura } from "../../../services/MinhasGuiasService";
import CheckIcon from "./CheckIcon";
import ErrorIcon from "./ErrorIcon";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";

function ActivationGuideModal(props: ActivationGuideModalProps){

    const [loading, setLoading] = useState<boolean>(false);
    const [sucess, setSucess] = useState<boolean>(false);
    const [failure, setFailure] = useState<boolean>(false);

    const accessibility = useAccessibility();

    const handleConfirmation = async () => {
        setLoading(true)
        const result = await ativarGuiaFutura(props.protocol);
        if(result !== null){
            setLoading(false);
            setSucess(true);
        }
        else {
            setLoading(false);
            setFailure(true);
        }
    }

    const handleClose = () => {
        setLoading(false);
        setFailure(false);
        if(sucess){
            setSucess(false);
            props.handleClose(true);
        }
        else {
            setSucess(false);
            props.handleClose(false);
        }
        
    }

    return (
        <div>
            <Modal
                open={props.open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                aria-live="polite"
            >
                <Box sx={sxModal} style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}>
                    {!loading &&
                        <div className="activation-guide-card-feedback-modal-header">
                            <button aria-label="fechar" className='activation-guide-card-modal-header-close' onClick={handleClose}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                    }
                    {loading && 
                        <div className="loading-holder">
                            <CircularProgress />
                        </div>
                    }
                    {!loading && sucess && !failure &&
                        <div className="activation-guide-card-modal-feedback">
                            <div className="icon-holder">
                                <CheckIcon/>
                            </div>
                            <h1 className="activation-guide-card-feedback-modal-title" style={accessibility.textStyleAccessibility}>
                                Atenção
                            </h1>
                            <p className="activation-guide-card-feedback-modal-message" style={accessibility.textStyleAccessibility}>
                                Processo concluído. Sua guia está AUTORIZADA. Guia: {props.protocol}
                            </p>
                        </div>
                    }
                    {!loading && !sucess && failure &&
                        <div className="activation-guide-card-modal-feedback">
                            <div className="icon-holder">
                                <ErrorIcon/>
                            </div>
                            <h1 className="activation-guide-card-feedback-modal-title" style={accessibility.textStyleAccessibility}>
                                Erro
                            </h1>
                            <p className="activation-guide-card-feedback-modal-message" style={accessibility.textStyleAccessibility}>
                                Houve um erro ao ativar a guia!
                            </p>
                        </div>
                    }
                    {!loading && !sucess && !failure &&
                        <div>
                            <h1 className="activation-guide-card-feedback-modal-title" style={accessibility.textStyleAccessibility}>
                                Ativar guia
                            </h1>
                            <p className="activation-guide-card-feedback-modal-message" style={accessibility.textStyleAccessibility}>
                                Deseja ativar a guia referente ao protocolo {props.protocol}?
                            </p>
                            <div className="activation-guide-card-button-holder align-center">
                                <div className="activation-guide-card-button">
                                    <Button
                                        variant="outlined"
                                        onClick={handleClose}
                                        sx={sxOutlinedButton}
                                        disabled={false}
                                        fullWidth>
                                        CANCELAR
                                    </Button>
                                </div>
                                <div className="activation-guide-card-button">
                                    <Button
                                        variant="contained"
                                        onClick={handleConfirmation}
                                        sx={sxButton}
                                        style={accessibility.buttonStyleAccessibility}
                                        disabled={false}
                                        fullWidth>
                                        <span style={accessibility.textTitleStyleAccessibility}>
                                            CONFIRMAR
                                        </span>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    }
                </Box>
            </Modal>
        </div>
    )
}

export default ActivationGuideModal;
